import { render, staticRenderFns } from "./MasterListTab.vue?vue&type=template&id=795d9639&scoped=true&"
import script from "./MasterListTab.vue?vue&type=script&lang=ts&"
export * from "./MasterListTab.vue?vue&type=script&lang=ts&"
import style0 from "./MasterListTab.vue?vue&type=style&index=0&id=795d9639&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d9639",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VRow})
